import { Component, ComponentInterface, h, Host, JSX, Prop, State } from '@stencil/core';
import { transformTagNames } from '../../global/transform-tag-name';
import { WorkbenchTheme, DEFAULT_WORKBENCH_THEME } from '../../shared/themes';

export type BadgeVariant = 'warning' | 'error' | 'success';

const ICON_WARNING = 'bds/exclamation-mark/16';
const ICON_ERROR = 'bds/close/24';
const ICON_SUCCESS = 'bds/checkmark/16';

/**
 * @slot - Custom icon placed within the element
 */
@Component({
  tag: 'wb-badge',
  styleUrl: 'badge.scss',
  shadow: true,
})
export class BadgeComponent implements ComponentInterface {
  /** The color scheme */
  @Prop({ reflect: true })
  public theme: WorkbenchTheme = DEFAULT_WORKBENCH_THEME;

  /** Color variant of the badge */
  @Prop({ reflect: true })
  public variant?: BadgeVariant;

  /** Optional border of the badge */
  @Prop({ reflect: true })
  public hasBorder: boolean = false;

  @State()
  private icon: string;

  public connectedCallback(): void {
    this.setIcon();
  }

  private TagNames = transformTagNames(this, 'wb-badge', ['wb-icon']);

  private setIcon = (): void => {
    switch (this.variant) {
      case 'warning':
        this.icon = ICON_WARNING;
        break;
      case 'error':
        this.icon = ICON_ERROR;
        break;
      case 'success':
        this.icon = ICON_SUCCESS;
    }
  };

  public render(): JSX.Element {
    const { WbIcon } = this.TagNames;

    return (
      <Host class="wb-badge">
        <div class="inner">{this.variant ? <WbIcon name={this.icon} /> : <slot />}</div>
      </Host>
    );
  }
}
